module.exports = "https://health.dajiuxing.com.cn/img/assets/login/Accurateicon.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Flogin%2FAccurateicon.png
// module id = HQNm
// module chunks = 93